<template>
  <v-expansion-panel v-if="interaction.interactionType === 'INTERVENTION'">
    <v-expansion-panel-content :value="interaction.isOpen" v-on:input="setInterventionState(interaction.id)" :id="interactionId">
      <div slot="header">
        <student-profile-intervention-header :intervention="interaction"
                                             :open="interaction.isOpen"/>
      </div>
      <student-profile-intervention-body :intervention="interaction"
                                         :open="interaction.isOpen"
                                         :reset="interaction.reset"/>
    </v-expansion-panel-content>
  </v-expansion-panel>
  <student-alert-row v-else-if="interaction.interactionType==='ALERT'" :alert="interaction.studentAlert"/>
  <student-exemption-row v-else :exemption="interaction.exemption"/>
</template>

<script>
  import StudentProfileInterventionBody from './StudentProfileInterventionBody'
  import StudentProfileInterventionHeader from './StudentProfileInterventionHeader'
  import { SET_INTERVENTION_SHOW_STATE } from '../../../store/mutation-types'
  import StudentExemptionRow from '../../exemption/StudentExemptionRow'
  import StudentAlertRow from '../../alert/StudentAlertRow'

  export default {
    components: {
      StudentAlertRow,
      StudentExemptionRow,
      StudentProfileInterventionHeader,
      StudentProfileInterventionBody
    },
    name: 'student-profile-interaction',
    props: ['interaction'],
    data () {
      return {}
    },
    methods: {
      setInterventionState (value) {
        this.$store.commit(SET_INTERVENTION_SHOW_STATE, value)
      }
    },
    computed: {
      interactionId () {
        return 'student-interaction-' + this.interaction.id
      }
    },
    watch: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/intervention/studentProfileIntervention/StudentProfileInteraction.vue